const officeAgent = {
    name: 'office',
    display_name: 'Office Assistant',
    color: '#4A90D9',
    icon: 'fa-light fa-building',
    short_description: 'Navigate & Act'
};
const baseCost = {
    model_used: 'gpt-4o',
    input_tokens: 120,
    output_tokens: 80,
    estimated_cost_usd: 0.002,
    tool_calls_count: 1
};
function makeEnvelope(responseId, content, conversationId = 'conv-1', turnNumber = 1) {
    return {
        response_id: responseId,
        conversation_id: conversationId,
        tenant_id: 'tenant-mock',
        turn_number: turnNumber,
        agent: officeAgent,
        blocks: [{ type: 'markdown', block_id: `${responseId}-b1`, block_index: 0, content }],
        feedback_id: `fb-${responseId}`,
        cost: baseCost,
        duration_ms: 320,
        created_at: new Date().toISOString(),
        agent_response: content,
        citations: [],
        deep_links: []
    };
}
export const mockConversations = [
    {
        id: 1,
        sessionId: 'conv-1',
        title: 'Show overdue inspections',
        lastAgent: 'office',
        messageCount: 4,
        lastActivityAt: new Date().toISOString(),
        createdAt: new Date().toISOString()
    },
    {
        id: 2,
        sessionId: 'conv-2',
        title: 'Export deficiency report for Building A',
        lastAgent: 'data',
        messageCount: 2,
        lastActivityAt: new Date(Date.now() - 86400000).toISOString(),
        createdAt: new Date(Date.now() - 86400000).toISOString()
    },
    {
        id: 3,
        sessionId: 'conv-3',
        title: 'NFPA 25 sprinkler requirements',
        lastAgent: 'code',
        messageCount: 3,
        lastActivityAt: new Date(Date.now() - 604800000).toISOString(),
        createdAt: new Date(Date.now() - 604800000).toISOString()
    },
    {
        id: 4,
        sessionId: 'conv-4',
        title: 'Quarterly inspection summary',
        lastAgent: 'data',
        messageCount: 6,
        lastActivityAt: new Date(Date.now() - 2592000000).toISOString(),
        createdAt: new Date(Date.now() - 2592000000).toISOString()
    }
];
function makeTallTableContent() {
    const rows = Array.from({ length: 100 }, (_, i) => `| ${i + 1} | Deficiency #${i + 1} | Open | No | 12-18-2025 | Building ${i + 1} |`).join('\n');
    return `Here are the 100 most recent deficiencies from 2025 that have no associated proposal line item.\n\n| # | Display Name | Status | Is Resolved | Date Opened | Building |\n|---|---|---|---|---|---|\n${rows}`;
}
export const mockMessagesWithTallTable = [
    {
        id: 'tall-msg-1',
        role: 'user',
        content: 'Show me all deficiencies from last year that do not have a proposal',
        created_at: new Date(Date.now() - 60000).toISOString()
    },
    {
        id: 'tall-msg-2',
        role: 'agent',
        content: makeTallTableContent(),
        agent: officeAgent,
        envelope: makeEnvelope('tall-resp-1', makeTallTableContent()),
        created_at: new Date(Date.now() - 55000).toISOString()
    }
];
export const mockMessages = [
    {
        id: 'msg-1',
        role: 'user',
        content: 'Show me all overdue inspections',
        created_at: new Date(Date.now() - 60000).toISOString()
    },
    {
        id: 'msg-2',
        role: 'agent',
        content: 'I found 3 overdue inspections. Here are the details:',
        agent: officeAgent,
        envelope: makeEnvelope('resp-1', 'I found **3 overdue inspections**. Here are the details:'),
        created_at: new Date(Date.now() - 55000).toISOString()
    },
    {
        id: 'msg-3',
        role: 'user',
        content: 'Can you export this as a CSV?',
        created_at: new Date(Date.now() - 30000).toISOString()
    },
    {
        id: 'msg-4',
        role: 'agent',
        content: "Sure! I've generated the CSV export. Click the download button below.",
        agent: officeAgent,
        envelope: makeEnvelope('resp-2', "Sure! I've generated the CSV export. Click the download button below.", 'conv-1', 2),
        created_at: new Date(Date.now() - 25000).toISOString()
    }
];
